<template>
  <div>
    <p class="f-gotham">
		<a :href="params['file']" target="_blank" class="hover-ani-arrow d-none d-sm-inline">
			<span class="align-middle d-inline-block">{{params['trans']['file_name']}}</span>
			&nbsp;
			<div class="d-inline-block align-middle">
                <div class="slider slider-down">
                    <div class="slide-1">
                        <img class="d-block" alt="Seta_Download_3.png" src="../../assets/images/Seta_Download_3.png">
                    </div>
                    <div class="slide-2">
						<img class="d-block" alt="Seta_Download_3.png" src="../../assets/images/Seta_Download_3.png">
					</div>
                </div>
			</div>
		</a>
        <a :href="params['file']" target="_blank" class="hover-ani-arrow d-sm-none d-inline" download>
            <span class="align-middle d-inline-block">{{params['trans']['file_name']}}</span>
            &nbsp;
            <div class="d-inline-block align-middle">
                <div class="slider slider-down">
                    <div class="slide-1">
                        <img class="d-block" alt="Seta_Download_3.png" src="../../assets/images/Seta_Download_3.png">
                    </div>
                    <div class="slide-2">
                        <img class="d-block" alt="Seta_Download_3.png" src="../../assets/images/Seta_Download_3.png">
                    </div>
                </div>
            </div>
        </a>
	</p>
  </div>
</template>
<script>
export default {
  name: 'strategic_principles',
  props: ['params']
}
</script>
<style scoped>
a {
	color: inherit;
	text-decoration: none;
}
a:hover span {
	text-decoration: underline;
}
.slider {
    display: inline-block;
    position: relative;
	width: 120px;
    height: 20px;
    overflow: hidden;
    cursor: pointer;
}
.slide-1 {
    position: absolute;
    top:0; left:0;
    height: 100%;
    width: 100%;
    font-size: 1.5em;
    transition: all .5s;
}
img {
	width: 19px;
}
a:hover .slider.slider-down .slide-1 { top: 100%; opacity:0; }

.slide-2 {
    position: absolute;
    height: 100%;
    width: 100%;
    transition: all .5s;
    opacity: 0;
}

.slider.slider-down .slide-2 { top: -100%; }


a:hover .slider.slider-down .slide-2 { top: 0; opacity: 1; }


</style>